import "./quienes-somos.scss";

export default function QuienesSomos() {
  const areas = [
    {
      icon: "bi-mic-fill",
      color: "cyan",
      title: "Voz",
      desc: "Evaluación y tratamiento de disfonías, nódulos, patologías laríngeas y trastornos de la voz.",
    },
    {
      icon: "bi-chat-dots-fill",
      color: "green",
      title: "Lenguaje",
      desc: "Intervención en retrasos y trastornos del desarrollo del lenguaje oral y escrito.",
    },
    {
      icon: "bi-ear-fill",
      color: "violet",
      title: "Audición",
      desc: "Diagnóstico y rehabilitación de hipoacusias, adaptación de audífonos y rehabilitación auditiva.",
    },
    {
      icon: "bi-activity",
      color: "amber",
      title: "Función Vestibular",
      desc: "Evaluación de trastornos del equilibrio y su rehabilitación vestibular.",
    },
    {
      icon: "bi-book-fill",
      color: "rose",
      title: "Aprendizaje",
      desc: "Trastornos de aprendizaje con alteraciones del lenguaje: dislexia, disgrafía, discalculia.",
    },
    {
      icon: "bi-shield-plus",
      color: "indigo",
      title: "Prevención",
      desc: "Acciones preventivas en salud comunicacional, screenings neonatales y escolares.",
    },
  ];

  const mission = [
    {
      color: "cyan",
      icon: "bi-bullseye",
      title: "Misión",
      desc: "Regular, controlar y promover el ejercicio ético de la fonoaudiología en La Pampa.",
    },
    {
      color: "green",
      icon: "bi-eye",
      title: "Visión",
      desc: "Ser referente provincial en la defensa de la profesión y los derechos de los pacientes.",
    },
    {
      color: "violet",
      icon: "bi-award",
      title: "Valores",
      desc: "Ética, transparencia, compromiso social y excelencia profesional.",
    },
    {
      color: "amber",
      icon: "bi-people",
      title: "Comunidad",
      desc: "Acompañamos a los profesionales en todas las etapas de su carrera.",
    },
  ];

  return (
    <section id="quienes-somos" className="section quienes-somos-page">
      <div className="container section-title fade-up text-center mb-5">
        <h2>¿Quiénes somos?</h2>
        <p>
          Conocé la institución que regula el ejercicio de la fonoaudiología en
          la Provincia de La Pampa.
        </p>
      </div>

      {/* ── Descripción + Misión/Visión ── */}
      <div className="container qs-about">
        <div className="row gy-4 align-items-center">
          <div className="col-lg-6">
            <h2 className="qs-about__title">La Institución</h2>
            <p className="qs-about__text">
              El Colegio Profesional de Fonoaudiólogos de la Provincia de La
              Pampa es una entidad creada por la{" "}
              <a
                href="/assets/portal/docs/LEY_N_2558.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="law-link"
              >
                <i className="bi bi-file-earmark-pdf-fill"></i> Ley Provincial
                Nº 2558
              </a>{" "}
              (11 de Mayo de 2010, BO 2893 del 25-05-2010), la cual le otorga la
              potestad para regular el ejercicio de la fonoaudiología en todo el
              territorio de la provincia.
            </p>
            <p className="qs-about__text">
              Como atribución fundamental, se le delegó el ejercicio del{" "}
              <strong>gobierno de la matrícula</strong> de los fonoaudiólogos
              habilitados para actuar profesionalmente en el ámbito de la
              provincia, y realizar el control de la actividad en todas sus
              modalidades.
            </p>
          </div>
          <div className="col-lg-6">
            <div className="qs-mission-grid">
              {mission.map((item) => (
                <div className="qs-mission-card" key={item.title}>
                  <div className={`qs-mission-card__icon ${item.color}`}>
                    <i className={`bi ${item.icon}`}></i>
                  </div>
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ── Grid de áreas ── */}
      <div className="qs-areas">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="qs-areas__title">
              <i className="bi bi-heart-pulse-fill"></i> Áreas de la
              Fonoaudiología
            </h2>
            <p className="qs-areas__subtitle">
              El ejercicio profesional abarca la prevención, evaluación,
              terapéutica e investigación en:
            </p>
          </div>
          <div className="row g-4">
            {areas.map((area) => (
              <div className="col-md-6 col-lg-4" key={area.title}>
                <div className="qs-area-card">
                  <div className={`qs-area-card__icon ${area.color}`}>
                    <i className={`bi ${area.icon}`}></i>
                  </div>
                  <h4>{area.title}</h4>
                  <p>{area.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Banner CTA Ley ── */}
      <div className="container qs-law-banner">
        <div className="qs-law-banner__inner">
          <div className="qs-law-banner__left">
            <div className="qs-law-banner__icon">
              <i className="bi bi-file-earmark-text-fill"></i>
            </div>
            <div>
              <h4>Marco Legal</h4>
              <p>
                Ley Provincial Nº 2558 — Creación del Colegio de Fonoaudiólogos
                de La Pampa · BO 2893 del 25-05-2010
              </p>
            </div>
          </div>
          <a
            href="/assets/portal/docs/LEY_N_2558.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="qs-law-banner__btn"
          >
            <i className="bi bi-file-earmark-pdf-fill"></i> Descargar PDF
          </a>
        </div>
      </div>
    </section>
  );
}
